import { useState } from "react";
import Analtics from "../../Assets/images/Analtics.svg";
import { Doughnut } from "react-chartjs-2";


const CountCards = ({ data }) => {
    const analyticsData = data
    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        cutout: "70%",
        plugins: {
            legend: {
                display: false,
            },
        },
    };
    const createChartData = (values) => ({
        labels: Object.keys(values),
        datasets: [
            {
                data: Object.values(values),
                backgroundColor: [
                    "#ff4d6d",
                    "#ff884d",
                    "#fbff12",
                    "#80ffdb",
                    "#ccff33",
                ],
                borderWidth: 0,
                datalabels: {
                    display: false
                }
            },
        ],
    });
    const cards = [
        {
            title: "Customers",
            total: analyticsData?.customers?.total,
            chart: createChartData({
                Verified: analyticsData?.customers?.verified,
                PartiallyVerified: analyticsData?.customers?.partiallyVerified,
                Unverified: analyticsData?.customers?.unVerified,
            }),
        },

        {
            title: "Bookings",
            total: analyticsData?.bookings?.total,
            chart: createChartData({
                Booked: analyticsData?.bookings?.booked,
                Ongoing: analyticsData?.bookings?.ongoing,
                Completed: analyticsData?.bookings?.completed,
                Pending: analyticsData?.bookings?.pending,
                Cancelled: analyticsData?.bookings?.cancelled,
            }),
        },

        {
            title: "Leads",
            total: analyticsData?.leads?.total,
            chart: createChartData({
                Following: analyticsData?.leads?.following,
                Converted: analyticsData?.leads?.converted,
                Closed: analyticsData?.leads?.closed,
                Rejected: analyticsData?.leads?.rejected,
            }),
        },
        {
            title: "Revenue",
            total: analyticsData?.revenue?.total,
            chart: createChartData(
                {
                    Collected: analyticsData?.revenue?.collected,
                    Pending: analyticsData?.revenue?.pending,

                }
            ),
        },
    ];
    return (
        <>
            {cards.map((card, index) => (
                <div className="analytics-card" key={index} >
                    <img src={Analtics} alt="" className="position-absolute start-0" />
                    <div className="p-3 d-flex justify-content-between align-items-center" style={{ position: "relative", zIndex: 2, }} >
                        <div>
                            <h4 className="analytics-title">{card.title}</h4>
                            <h3>{Number(card.total).toLocaleString()}</h3>
                        </div>

                        <div style={{ width: "90px", height: "90px", }} >
                            <Doughnut
                                data={card.chart}
                                options={chartOptions}
                            // plugins={[
                            //     createCenterTextPlugin(
                            //         card.total
                            //     ),
                            // ]}
                            />
                        </div>
                    </div>
                </div>
            ))}
        </>
    )
}

export default CountCards;